import {
  productIdFormat,
  supplierIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const addProductsToSupplier = {
  name: "addProductsToSupplier" as const,
  input: z.object({
    supplierIds: z.array(supplierIdFormat.schema),
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ addedCount: z.number().int() }),
};
